import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CoreModule } from '../core/core.module';
import { AppModuleGlobalShared } from '../../app.module.global';
import { BuscadorEspeciesListComponent } from '../_comunes/buscadorEspecies/buscadorespecies-list.component';
import { BuscadorEspeciesDetailComponent } from '../_comunes/buscadorEspecies/buscadorespecies-detail.component';
import { LoginGuard } from '../core/_infrastructure/classes/guards/main.guard';
import { CorreoUsuarioListComponent } from './correosUsuario/correosusuario-list.component';
import { CorreosUsuarioService } from './correosUsuario/correosusuario.service';
import { SpinnerComponent } from './spinner/spinner.component';

@NgModule({
    declarations: [BuscadorEspeciesListComponent, BuscadorEspeciesDetailComponent, CorreoUsuarioListComponent, SpinnerComponent],
    exports: [BuscadorEspeciesListComponent, SpinnerComponent],
    imports: [
        CoreModule,
        AppModuleGlobalShared,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule.forRoot([
            {
                path: 'global/buscadorEspecies',
                data: {
                    breadcrumb: 'Buscador de Especies',
                    menu0: 'GLOBAL',
                },
                children: [
                    {
                        path: '',
                        component: BuscadorEspeciesListComponent,
                        canActivate: [LoginGuard()],
                    },
                    {
                        path: 'detail/:id',
                        component: BuscadorEspeciesDetailComponent,
                        canActivate: [LoginGuard()],
                        data: {
                            breadcrumb: 'Detalle Especie',
                        },
                    },
                ],
            },
            {
                path: 'global/correosusuario',
                data: {
                    breadcrumb: 'Reglas de Correo',
                    menu0: 'GLOBAL',
                },
                children: [
                    {
                        path: '',
                        component: CorreoUsuarioListComponent,
                        canActivate: [LoginGuard()],
                    },
                ],
            },
        ]),
    ],
    providers: [CorreosUsuarioService],
})
export class ComunesModule {}
